import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { MingaPermission } from 'libs/domain';
import { gateway } from 'libs/generated-grpc-web';
import { ReplaySubject } from 'rxjs';

import { IEmptyStateIcon } from '@app/src/app/components/EmptyState';
import {
  IShortCardChallengeClickEvent,
  IShortCardChallengeResponseClickEvent,
} from '@app/src/app/elements/MgShortCard/MgChallengeShortCard';
import { GroupsFacadeService } from '@app/src/app/groups/services';
import { ContentEvents } from '@app/src/app/minimal/services/ContentEvents';
import { PollAnswerStateService } from '@app/src/app/minimal/services/PollAnswerState';
import { PermissionsService } from '@app/src/app/permissions';
import { ContentState } from '@app/src/app/services/ContentState';

@Component({
  selector: 'mg-home-challenges',
  templateUrl: './home-challenges.component.html',
  styleUrls: ['./home-challenges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeChallengesComponent implements OnDestroy {
  // Clean up
  private readonly _destroyedSubject = new ReplaySubject<void>(1);

  emptyStateIcons: IEmptyStateIcon[] = [];
  canCreateChallenges = false;

  feedFilter: any = {
    contentType: 'CHALLENGE',
  };

  /** Component constructor */
  constructor(
    public pollAnswerService: PollAnswerStateService,
    public contentEvents: ContentEvents,
    public groupsFacade: GroupsFacadeService,
    public contentState: ContentState,
    public contentFeed: gateway.feed_ng_grpc_pb.ContentFeed,
    private _permissions: PermissionsService,
  ) {
    // load groups for group feed content
    groupsFacade.dispatchLoadAll();

    this.emptyStateIcons = [
      {
        icon: 'post',
        text: 'Add',
      },
      {
        icon: 'challenges-o',
        text: 'Challenge',
      },
    ];

    this.canCreateChallenges = this._permissions.hasPermission(MingaPermission.CONTENT_CHALLENGE_CREATE);
  }

  ngOnDestroy(): void {
    this._destroyedSubject.next();
    this._destroyedSubject.complete();
  }

  onChallengeClick(ev: IShortCardChallengeClickEvent) {
    this.contentEvents.emitContentOpen({
      contentContextHash: ev.challengeContextHash,
    });
  }

  onChallengeResponseClick(ev: IShortCardChallengeResponseClickEvent) {
    this.contentEvents.emitContentOpen({
      contentContextHash: ev.responseContextHash,
    });
  }
}
